import { render, staticRenderFns } from "./McnTaskFollow.vue?vue&type=template&id=723ff6d0&scoped=true&"
import script from "./McnTaskFollow.vue?vue&type=script&lang=js&"
export * from "./McnTaskFollow.vue?vue&type=script&lang=js&"
import style0 from "./McnTaskFollow.vue?vue&type=style&index=0&id=723ff6d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723ff6d0",
  null
  
)

export default component.exports